import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var BankAccount = function BankAccount(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4857 2.12584C12.1837 1.95805 11.8165 1.95805 11.5144 2.12584L2.51445 7.12584C2.11612 7.34714 1.91776 7.80974 2.03206 8.25084C2.14637 8.69195 2.54442 9 3.00009 9H21.0001C21.4558 9 21.8538 8.69195 21.9681 8.25084C22.0824 7.80974 21.8841 7.34714 21.4857 7.12584L12.4857 2.12584ZM12.0001 4.14396L17.141 7H6.85922L12.0001 4.14396Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19C2.44772 19 2 19.4477 2 20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20C22 19.4477 21.5523 19 21 19H19V10.9565C19 10.4282 18.5523 10 18 10C17.4477 10 17 10.4282 17 10.9565L17 18H13V10.9167C13 10.4104 12.5523 10 12 10C11.4477 10 11 10.4104 11 10.9167L11 18H7L7 10.9167C7 10.4104 6.55228 10 6 10C5.44772 10 5 10.4104 5 10.9167L5 18.9993L3 19Z",
    fill: color
  }));
};

export { BankAccount };
